module.exports = __webpack_public_path__ + "img/payroll-icon3.79c32a96.svg";